import { IPaginatedResponse, IResponse } from "../../../model";
import { IProductoSimuladorParam, IProductoSimuladorResult } from "../../../model/ICalcularProducto";
import ServiceBase from "../../../servicebase";
import { IProductoPais, IProductoRegion, IProductoSegmento, IProductoPrestacion, IProductoPrecio, IProductoPromocion, IProductoUpgradesEdit } from "../model";
import { IProducto } from "../model/IProducto";

export default class ProductoService extends ServiceBase {
  all = () : Promise<IResponse<IProducto[]>> => 
    this.GetFetch<IResponse<IProducto[]>>('entity/producto/all', {});

  get = (data:{ id?: number }) : Promise<IResponse<IProducto>> => 
    this.GetFetch<IResponse<IProducto>>('entity/producto', data);

  find = (data:{ pageIndex?: number, pageSize?: number, sort?: string, id?: number, codigo?: number, nombre?: string, idproveedor?: number, proveedor?: string, estados?: string, activo?: boolean }) : Promise<IPaginatedResponse<IProducto>> => 
    this.GetFetch<IPaginatedResponse<IProducto>>('entity/producto/find', data);

  upsert = (data:IProducto) : Promise<IResponse<IProducto>> => 
    this.PostFetch<IResponse<IProducto>>('entity/producto', data);

  delete = (data:{ id: number, undelete?: boolean}) : Promise<IResponse<void>> => 
    this.DeleteFetch<IResponse<void>>('entity/producto', data);

  paises_all = (data: { idProducto?: number }) : Promise<IResponse<IProductoPais[]>> =>
    this.GetFetch<IResponse<IProductoPais[]>>('entity/producto/paises/all', data);

  regiones_all = (data: { idProducto?: number }) : Promise<IResponse<IProductoRegion[]>> =>
    this.GetFetch<IResponse<IProductoRegion[]>>('entity/producto/regiones/all', data);

  segmentos_all = (data: { idProducto?: number }) : Promise<IResponse<IProductoSegmento[]>> =>
    this.GetFetch<IResponse<IProductoSegmento[]>>('entity/producto/segmentos/all', data);

  prestaciones_all = (data: { idProducto?: number }) : Promise<IResponse<IProductoPrestacion[]>> =>
    this.GetFetch<IResponse<IProductoPrestacion[]>>('entity/producto/prestaciones/all', data);

  precios_all = (data: { idProducto?: number }) : Promise<IResponse<IProductoPrecio[]>> =>
    this.GetFetch<IResponse<IProductoPrecio[]>>('entity/producto/precios/all', data);

  promociones_all = (data: { idProducto?: number }) : Promise<IResponse<IProductoPromocion[]>> =>
    this.GetFetch<IResponse<IProductoPromocion[]>>('entity/producto/promociones/all', data);

  upgrades_all = (data: { idProducto?: number }) : Promise<IResponse<IProductoUpgradesEdit[]>> =>
    this.GetFetch<IResponse<IProductoUpgradesEdit[]>>('entity/producto/upgrades/all', data);

  calcular = (data:IProductoSimuladorParam) : Promise<IResponse<IProductoSimuladorResult>> => 
    this.PutFetch<IResponse<IProductoSimuladorResult>>('entity/producto/calcular', data);
}
